import styled from '@emotion/styled';
import {
  BlockContentWrapper,
  BlockWrapper,
  BlockDescription,
  BlockHeader,
  BlockTitle,
  CUSTOM_BREAK_POINT,
  BackgroundImage,
} from '../Block.styled';
import BenefitItem from './BenefitItem';
import { Fade } from 'react-awesome-reveal';
import GrowUpDetail from './GrowUpDetail';
import GroupUpImages from './GroupUpImages';

type Props = {
  id: string;
};

const Benefit = (props: Props) => {
  return (
    <BlockWrapper id={props.id}>
      <BackgroundImage
        src='/images/background/meteo_right.png'
        top={-150}
        left={-50}
        size={193}
      />
      <BackgroundImage
        src='/images/background/meteo_right.png'
        top={70}
        left={50}
        size={134}
      />
      <BackgroundImage
        src='/images/background/circle2.png'
        top={70}
        right={50}
        size={125}
      />
      <BlockHeader>
        <Fade cascade damping={0.3} direction='up' triggerOnce>
          <BlockTitle>Benefit</BlockTitle>
          <BlockDescription>
            꺼미는 보유한 누구나 혜택을 얻어가실 수 있습니다. 꺼미 성장하는
            NFT이며, 성장에 따른 혜택 구조가 다릅니다.
            <br />
            구체적인 혜택은 하단을 참고해주세요! 아래 혜택은 모두 월 기준입니다.
          </BlockDescription>
        </Fade>
      </BlockHeader>
      <BlockContentWrapper>
        <BenefitWrapper>
          <Fade
            cascade
            damping={0.3}
            direction='down'
            delay={700}
            duration={700}
            triggerOnce
          >
            <BenefitItem
              mintInfo='발행개수: 100개 10%'
              rarity='BRONZE'
              benefits={['편의점 모바일 상품권 : 3 회']}
              color='#F7AEDC'
              badgeImage='/images/bronze.png'
              image='/images/gummy_bronze.png'
              size={101}
            />
            <BenefitItem
              mintInfo='발행개수: 150개 15%'
              rarity='SILVER'
              benefits={[
                '편의점 모바일 상품권 4,000원(매월)',
                '과자 키트 + 에코백(최초 1회 제공)',
                '콜라보 NFT 프로젝트 화이트리스트',
              ]}
              color='#ADE6FE'
              badgeImage='/images/silver.png'
              image='/images/gummy_silver.png'
              size={150}
            />
            <BenefitItem
              mintInfo='발행개수: 50개 5%'
              rarity='GOLD'
              benefits={[
                '편의점 모바일 상품권 : 3 회',
                '편의점 모바일 상품권 : 3 회',
                '백화점 3시간 무료 주차권 : 5 매',
              ]}
              color='#F8E338'
              badgeImage='/images/gold.png'
              image='/images/gummy_gold.png'
              size={204}
              hidden
            />
          </Fade>
        </BenefitWrapper>
        <GrowUpWrapper>
          <GrowUpDetail />
          <GroupUpImages />
        </GrowUpWrapper>
      </BlockContentWrapper>
    </BlockWrapper>
  );
};

const BenefitWrapper = styled.section`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 80px;

  width: 100%;
  /* min-width: 480px; */

  height: 100%;
`;

const GrowUpWrapper = styled.section`
  display: flex;
  justify-content: center;
  gap: 180px;
  flex-wrap: wrap;

  max-width: 1300px;
  width: 100%;
  height: 100%;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    justify-content: center;
  }
`;

export default Benefit;
